export const FUNCTIONALITY = {
    BOOKING: 'BOOKING',
    EQUIPMENT: 'EQUIPMENT',
    CBL: 'CBL',
    FCR: 'FCR',
    Document: 'Document',
    ETS: 'ETS'
}
export const SELECTED_LEVEL = {
    BOOKING: 1,
    EQUIPMENT: 2,
    CBL: 3,
    FCR: 4
}
export const CATEGORY = {
    ISSO: 'ISSO',
    ESSO: 'ESSO'
}